import { InstanceScreen } from 'component/navigation/instance';

export default function ProfileInstanceScreen() {
    return <InstanceScreen />;
}
